import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";


const updates = [
  {
    title: "📚 Feature Enhancements",
    description: "New tools to improve booklist creation, sorting, and compatibility across devices.",
    img: "/assets/4.png",
  },
  {
    title: "💎 Membership Benefits",
    description: "Unlock exclusive booklist templates, unlimited public booklists, and premium themes.",
    img: "/assets/5.png",
  },
  {
    title: "🌍 Upcoming Innovations",
    description: "We are exploring AI-powered book recommendations, community sharing features, and interactive discussions.",
    img: null, // 这里不放图片
  },
];

const UpdatesSection = () => {
  return (
    <section id="updates" className="section section-gray">
      <h2>🚀 Future Updates</h2>
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={20}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000 }}
        className="update-swiper"
      >
        {updates.map((update, index) => (
          <SwiperSlide key={index} className="update-card">
            {update.img ? (
              <img src={update.img} alt={update.title} className="update-image" />
            ) : (
              <div className="update-placeholder">🚧 More Features Coming Soon...</div>
            )}
            <div className="update-text">
              <h3>{update.title}</h3>
              <p>{update.description}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default UpdatesSection;
